import React, { Fragment } from 'react';
import './border.scss';
export const Border = () => {
  return (
    <div className="d-flex flex-column w-100 height-invice left-to-right  ">
      <div className="d-flex ">
        <div className="bottom-left-inside-carve-invice w-100 " />
        <div className="bottom-right-inside-carve-invice  w-100" />
      </div>
      <div className="d-flex justify-content-center align-items-center w-100 ">
        <div className="d-flex justify-content-center align-items-center bg-white border-element-width-border-invice">
          <div className=" w-75  border-cw-invice  " />
        </div>
      </div>
      <div className="d-flex  ">
        <div className="top-left-inside-carve-invice w-100 " />
        <div className="top-right-inside-carve-invice  w-100 " />
      </div>
    </div>
  );
};
